export default "__VITE_ASSET__BklEtYW8__"